import * as dayjs from 'dayjs';

export const getPeriod = (): string => {
  return dayjs().format('YYYY-MM');
};
